import FormInput from "@form/FormInput";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Blockquote } from "@ui";
import Link from "next/link";
import useSWR from "swr";
import { useTranslation } from "react-i18next";
import { useClubSlug } from "../../Clubs/hooks";
import Loader from "../../Loader";

interface Props {
    name?: string;
    clubSlug?: string;
}

const DeviceManagerInput = ({ name = "access_devices", clubSlug: _clubSlug }: Props) => {
    const { t } = useTranslation('access');
    const clubSlug = useClubSlug(_clubSlug);
    const { data, isLoading } = useSWR(`access-control/device/${clubSlug}`);

    return (
        (<Loader isLoading={isLoading}>
            <div className="tw-my-4">
                {data?.data.length ? (
                    <>
                        <Blockquote className="!tw-mb-3 !tw-mt-0">
                            <span className="tw-mb-3 tw-flex tw-items-center tw-text-xl">
                                <FontAwesomeIcon icon={faLock} className="mr-3" />
                                {t('deviceManagerInput.title')}
                            </span>
                            {t('deviceManagerInput.withDevices')}
                        </Blockquote>
                        <FormInput.MultipleSelect
                            name={name}
                            label={t('deviceManagerInput.selectLabel')}
                            options={data?.data?.map((device) => ({
                                id: device.id,
                                label: device.name,
                            }))}
                        />
                    </>
                ) : (
                    <Blockquote className="!tw-mb-3 !tw-mt-0">
                        <span className="tw-mb-3 tw-flex tw-items-center tw-text-xl">
                            <FontAwesomeIcon icon={faLock} className="mr-3" />
                            {t('deviceManagerInput.title')}
                        </span>
                        {t('deviceManagerInput.withoutDevicesText')}
                        <Link
                            href="/kontakt"
                            className="tw-mt-4 tw-block tw-rounded-lg tw-bg-success tw-px-2 tw-py-1 tw-text-center tw-text-white tw-transition-colors hover:tw-bg-success/90 hover:tw-text-white">
                            {t('deviceManagerInput.cta')}
                        </Link>
                    </Blockquote>
                )}
            </div>
        </Loader>)
    );
};

export default DeviceManagerInput;
